import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import LocationForm from '../location_form/LocationForm';
import {
	locationsRestCrudThunksForBuyer,
	locationsRestCrudThunksForSupplier,
} from '../../thunks/locations_thunks';
import { EditPage } from '../edit_page/EditPage';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { getEntityById } from '../../utils/DataAccessUtils';

const style = require('./EditLocationPage.less');

class EditLocationPage extends React.Component<any, any> {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		const { getLocation, match } = this.props;
		const locationId = match.params.id;
		getLocation(locationId);
	}

	render() {
		const { history, location, fetching } = this.props;

		//noinspection TypeScriptUnresolvedVariable
		return [
			<EditPage
				title="Edit Location"
				formComponentProps={{
					formData: location,
					onSuccess: (rec) => history.goBack(),
				}}
				fetching={fetching}
				FormComponent={LocationForm}
			/>,
		];
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		history: ownProps.history,
		location: getEntityById(ownProps.match.params.id, state.locations),
		fetching: state.locations.fetching,
		match: ownProps.match,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	getLocation: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? locationsRestCrudThunksForSupplier.readOne(id)
				: locationsRestCrudThunksForBuyer.readOne(id)
		),
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(EditLocationPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
